import type { ReactElement } from 'react'
import LandingPage from './pages/LandingPage'
import FeaturesPage from './pages/FeaturesPage'
import HowItWorksPage from './pages/HowItWorksPage'
import CoveragePage from './pages/CoveragePage'
import PricingPage from './pages/PricingPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import StatePage from './pages/StatePage'
import GovernmentBidsPage from './pages/GovernmentBidsPage'
import GuidesPage from './pages/GuidesPage'
import GuidePage from './pages/GuidePage'
import { STATES } from './content/states'
import { GUIDES } from './content/guides'

export interface AppRoute {
  path: string
  element: ReactElement
}

/** Single route table shared by the client router and the SSR prerender. */
export const APP_ROUTES: AppRoute[] = [
  { path: '/', element: <LandingPage /> },
  { path: '/features', element: <FeaturesPage /> },
  { path: '/how-it-works', element: <HowItWorksPage /> },
  { path: '/coverage', element: <CoveragePage /> },
  { path: '/pricing', element: <PricingPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/guides', element: <GuidesPage /> },
  ...GUIDES.map((guide) => ({
    path: `/guides/${guide.slug}`,
    element: <GuidePage guide={guide} />,
  })),
  ...STATES.map((state) => ({
    path: `/government-bids/${state.slug}`,
    element: <StatePage state={state} />,
  })),
  { path: '/government-bids', element: <GovernmentBidsPage /> },
]
